<template>
  <nav class="w-full bg-agency-blue sticky top-0 z-20">
    <div class="w-full max-w-screen-xl mx-auto px-10 h-20 flex items-center justify-between">
      <router-link to="/" class="w-16 h-16 shrink-0">
        <img class="w-full h-full object-contain" src="./assets/MxTravel.png" alt="Mx Travel">
      </router-link>
      <div class="hidden items-center gap-x-10 lg:flex">
        <router-link
        to="/blogs"
        active-class="text-agency-orange"
        class="font-display font-semibold text-agency-white text-lg transition-colors hover:text-agency-orange">Articulos de viaje</router-link>
        <router-link
        to="/conocenos"
        active-class="text-agency-orange"
        class="font-display font-semibold text-agency-white text-lg transition-colors hover:text-agency-orange">Conocenos</router-link>
        <router-link
        :to="{ path:'/conocenos', hash: '#cotizar' }"
        class="h-12 px-7 flex items-center font-display font-bold text-agency-white bg-agency-orange rounded-tl-full rounded-br-full transition-all delay-100
        hover:rounded-tr-full hover:rounded-bl-full hover:rounded-tl-none hover:rounded-br-none">Cotiza con nosotros</router-link>
      </div>
      <button
      @click="menu_active"
      aria-label="Menu"
      class="w-10 h-10 flex items-center justify-center text-agency-white lg:hidden">
        <svg v-if="!show_menu" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M4 7h16M4 12h16M4 17h16"/>
        </svg>
        <svg v-else class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M18 6L6 18"/>
        </svg>
      </button>
    </div>
    <div
    v-if="show_menu"
    class="fixed top-20 left-0 right-0 bottom-0 bg-agency-blue border-t border-agency-white/20 overflow-y-auto overscroll-contain px-10 py-10 flex flex-col lg:hidden">
      <router-link @click="show_menu = false" to="/"
      class="py-5 border-b border-agency-white/15 font-display font-semibold text-agency-white text-2xl">Inicio</router-link>
      <router-link @click="show_menu = false" to="/blogs"
      class="py-5 border-b border-agency-white/15 font-display font-semibold text-agency-white text-2xl">Articulos de viaje</router-link>
      <router-link @click="show_menu = false" to="/conocenos"
      class="py-5 border-b border-agency-white/15 font-display font-semibold text-agency-white text-2xl">Conocenos</router-link>
      <router-link @click="show_menu = false" :to="{ path:'/conocenos', hash: '#cotizar' }"
      class="h-14 mt-10 w-full flex items-center justify-center font-display font-bold text-agency-white bg-agency-orange rounded-tl-full rounded-br-full">Cotiza con nosotros</router-link>
      <div class="mt-auto pt-10 flex flex-col gap-y-3">
        <a href="mailto:cotizaciones@agenciamxtravel.com" class="text-agency-white/70">cotizaciones@agenciamxtravel.com</a>
        <a target="_blank" href="https://wa.me/526145997193" class="text-agency-white/70">+52 614 599 7193</a>
      </div>
    </div>
  </nav>
  <router-view/>
  <footer class="w-full bg-agency-blue">
    <div class="w-full max-w-screen-xl mx-auto px-10 py-14 grid gap-12 md:grid-cols-3">
      <div>
        <img class="w-24 h-24 object-contain -ml-2" src="./assets/MxTravel.png" alt="Mx Travel">
        <p class="text-agency-white/80 mt-3 max-w-xs">Planeamos tus vacaciones sin estrés: destinos, trámites y reservaciones en un solo lugar.</p>
        <div class="flex gap-x-3 mt-6">
          <a target="_blank" aria-label="Instagram" href="https://www.instagram.com/mxtravelcuu?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
          class="w-11 h-11 rounded-full bg-agency-white/10 flex items-center justify-center transition-colors hover:bg-agency-white/25">
            <img class="w-5 h-5" src="./assets/footer_icons/instagram.png" alt="">
          </a>
          <a target="_blank" aria-label="Facebook" href="https://www.facebook.com/agenciamxtravel"
          class="w-11 h-11 rounded-full bg-agency-white/10 flex items-center justify-center transition-colors hover:bg-agency-white/25">
            <img class="w-5 h-5" src="./assets/footer_icons/logo-de-facebook.png" alt="">
          </a>
          <a target="_blank" aria-label="TikTok" href="https://www.tiktok.com/@mxtravelcuu?is_from_webapp=1&sender_device=pc"
          class="w-11 h-11 rounded-full bg-agency-white/10 flex items-center justify-center transition-colors hover:bg-agency-white/25">
            <img class="w-5 h-5" src="./assets/footer_icons/tik-tok.png" alt="">
          </a>
        </div>
      </div>
      <div>
        <h3 class="text-agency-white mb-5">Navegación</h3>
        <div class="flex flex-col gap-y-3">
          <router-link to="/" class="text-agency-white/80 transition-colors hover:text-agency-orange">Inicio</router-link>
          <router-link to="/blogs" class="text-agency-white/80 transition-colors hover:text-agency-orange">Articulos de viaje</router-link>
          <router-link to="/conocenos" class="text-agency-white/80 transition-colors hover:text-agency-orange">Conocenos</router-link>
          <router-link :to="{ path:'/conocenos', hash: '#cotizar' }" class="text-agency-white/80 transition-colors hover:text-agency-orange">Cotiza con nosotros</router-link>
        </div>
      </div>
      <div>
        <h3 class="text-agency-white mb-5">Contacto</h3>
        <div class="flex flex-col gap-y-4">
          <a href="mailto:cotizaciones@agenciamxtravel.com" class="flex items-center gap-x-3 group">
            <img class="w-5 h-5 shrink-0" src="./assets/footer_icons/correo-electronico.png" alt="">
            <p class="text-agency-white/80 transition-colors group-hover:text-agency-orange">cotizaciones@agenciamxtravel.com</p>
          </a>
          <a target="_blank" href="https://wa.me/526145997193" class="flex items-center gap-x-3 group">
            <svg class="w-5 h-5 shrink-0 text-agency-white/80" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.5 5.5c0-1.1.9-2 2-2h2.2c.9 0 1.6.6 1.8 1.4l.8 3c.2.7-.1 1.4-.7 1.8l-1.4.9a13.5 13.5 0 006.2 6.2l.9-1.4c.4-.6 1.1-.9 1.8-.7l3 .8c.8.2 1.4 1 1.4 1.8v2.2c0 1.1-.9 2-2 2h-1C10.2 21.5 2.5 13.8 2.5 6.5v-1z"/>
            </svg>
            <p class="text-agency-white/80 transition-colors group-hover:text-agency-orange">+52 614 599 7193</p>
          </a>
          <p class="text-agency-white/80 max-w-xs">Paseos de San Carlos 14962, Col. Paseos de Chihuahua. Chihuahua, Chihuahua</p>
        </div>
      </div>
    </div>
    <div class="border-t border-agency-white/20">
      <div class="w-full max-w-screen-xl mx-auto px-10 py-5">
        <p class="text-agency-white/60 text-center">© {{ current_year }} Mx Travel. Todos los derechos reservados.</p>
      </div>
    </div>
  </footer>

</template>
<script setup>
import { onBeforeMount, onBeforeUnmount, onMounted, ref, watch, } from 'vue';
import { useRoute } from 'vue-router';

const show_menu = ref(false)
const router = useRoute()
const current_year = new Date().getFullYear()
const menu_active = () => { show_menu.value = !show_menu.value }
watch(() => router.path, () =>{
  show_menu.value = false
})

// Bloquea el scroll de la página mientras el menú de mobile está abierto.
watch(show_menu, (open) => {
  document.documentElement.style.overflow = open ? 'hidden' : ''
  document.body.style.overflow = open ? 'hidden' : ''
})

// Si se pasa a desktop con el menú abierto, el panel se oculta por CSS
// pero el scroll seguiría bloqueado: cerramos el menú para desbloquearlo.
const close_on_desktop = () => {
  if (window.innerWidth >= 1024) show_menu.value = false
}
onMounted(() => window.addEventListener('resize', close_on_desktop))
onBeforeUnmount(() => {
  window.removeEventListener('resize', close_on_desktop)
  document.documentElement.style.overflow = ''
  document.body.style.overflow = ''
})

onBeforeMount(() => {
  document.title = "Agencia de Viajes | Mx Travel";
})
</script>

